// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__dwI7C","title":"styles_title__1LzrA"};